import createAxiosInstance from '@/utils/requset'

const apiInstances = {
    api1: createAxiosInstance('api1'),
    api2: createAxiosInstance('api2'),
};

//获取字典配置
export function getDict(parameter) {
    return apiInstances.api2({
        url: '/common/get_dict',
        method: 'get',
        params: parameter
    })
}

//作者认证-上传认证图片
export function uploadAuthImg(data) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/auth/save_img',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//保存认证信息
export function saveAuth(data) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/auth/save',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//作者认证-我的认证信息
export function getAuthInfo(parameter) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/auth/info',
        method: 'get',
        params: parameter
    })
}

//我的空间背景
export function getZoneList(parameter) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/zone/list',
        method: 'get',
        params: parameter
    })
}

//设置背景
export function setBackground(parameter) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/zone/set_default',
        method: 'get',
        params: parameter
    })
}

//空间背景-上传背景图片
export function uploadZoneImg(data) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/zone/save_img',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//空间背景-保存
export function saveZone(data) {
    return apiInstances.api2({
        url: '/api/v1/comic1/upload/author/zone/save',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//获取字典配置
export function getConfigList(parameter) {
    return apiInstances.api2({
        url: '/api/v1/comic1/config',
        method: 'get',
        params: parameter
    })
}

//我的待处理
export function passport(data) {
    return apiInstances.api1({
        url: '/v1/u_center/passport/message',
        method: 'post',
        data: data,
    })
}